import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../../../config/app-constants';
import {
    ACCESSIBILITY_STATEMENT,
    LEGAL_NOTICE,
    PRIVACY_CHOICES,
    PRIVACY_POLICY,
    SECURITY
} from '../../../../treo.properties';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
    currentDate: number;
    footerData = [
        {
            label: 'Terms & Conditions',
            link: 'publicTermsConditions'
        },
        {
            label: 'Privacy Policy',
            link: PRIVACY_POLICY
        },
        {
            label: 'Your California Privacy Choices',
            link: PRIVACY_CHOICES,
            src: 'https://s0.hfdstatic.com/sites/the_hartford/images/privacyoptions.svg'
        },
        {
            label: 'Legal Notice',
            link: LEGAL_NOTICE
        },
        {
            label: 'Security',
            link: SECURITY
        },
        {
            label: 'Accessibility Statement',
            link: ACCESSIBILITY_STATEMENT
        }
    ];

    ngOnInit() {
        if (location.pathname.includes('print-dashboard')) {
            this.footerData = [];
        }
        this.currentDate = new Date().getFullYear();
    }
    termsAndcondition() {
        window.open('publicTermsConditions', '_blank', 'width=800,height=500');
    }
    privacyChoices() {
        const urls = {
            DEV: 'https://devwww.thehartford.com/data-privacy-opt-out-form',
            QA: 'https://qawww.thehartford.com/data-privacy-opt-out-form',
            PTE: 'https://thehartford.com/data-privacy-opt-out-form',
            PROD: 'https://www.thehartford.com/data-privacy-opt-out-form',
            default: 'https://www.thehartford.com/data-privacy-opt-out-form'
        };
        const env = AppConstants.ENV;
        const url = urls[env] || urls.default;
        const newWindow = window.open(url, '_blank', 'width=800,height=500');
        if (newWindow) {
            newWindow.opener = null;
        }
    }
}
